import * as ko from "knockout";
import * as $ from "jquery";
ko.bindingHandlers.redrawIcons = {
    update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        var enabled = ko.toJS(valueAccessor());
        $(".fa, .glyphicon", element).each(function () {
            var classes = $(this).attr("class");
            $(this).attr("class", "");
            $(this).attr("class", classes);
        });
    }
};